module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Auxilium Solutions","short_name":"Auxilium Solutions","start_url":"/","background_color":"#358a93","theme_color":"#358a93","display":"minimal-ui","icon":"src/assets/logo/symbol.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"b294c4bf0f976a9c495561ed2b52ab40"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
